import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin } from 'lucide-react';
const buyers = [{
  name: 'Valentina M.',
  city: 'Córdoba'
}, {
  name: 'Martina G.',
  city: 'CABA'
}, {
  name: 'Lucía F.',
  city: 'Rosario'
}, {
  name: 'Camila R.',
  city: 'Mendoza'
}, {
  name: 'Sofía L.',
  city: 'La Plata'
}, {
  name: 'Julieta S.',
  city: 'Mar del Plata'
}, {
  name: 'Florencia P.',
  city: 'Tucumán'
}, {
  name: 'Agustina B.',
  city: 'Neuquén'
}];
export const PurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Hide after 4 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 5000);
    // Recurring interval
    const intervalTimer = setInterval(() => {
      showPopup();
    }, 25000); // Show every 25 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-118">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border border-barre-border p-4 flex items-center gap-4 max-w-sm" data-id="element-119">
          <div className="w-12 h-12 bg-barre-blush rounded-full flex items-center justify-center flex-shrink-0" data-id="element-120">
            <span className="text-barre-pink font-bold text-lg" data-id="element-121">
              {currentBuyer.name.charAt(0)}
            </span>
          </div>
          <div data-id="element-122">
            <p className="text-sm text-gray-600" data-id="element-123">Alguien acaba de comprar</p>
            <p className="font-semibold text-gray-900 text-sm" data-id="element-124">
              Barre: La evolución de tu estudio
            </p>
            <div className="flex items-center gap-1 mt-1 text-xs text-gray-500" data-id="element-125">
              <MapPin className="w-3 h-3" data-id="element-126" />
              <span data-id="element-127">
                {currentBuyer.name} desde {currentBuyer.city}
              </span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};